// pages/sitetop.tsx

import dynamic from 'next/dynamic';

import { SelectableDataSetting } from '../components/SwitchDataSetting';

const Data3dRegistration = dynamic(
  () => import('../components/Data3dRegistration').then((module) => module.Data3dRegistration),
  {
    ssr: false,
  }
);
const CesiumViewer = dynamic(
  () => import('@/features/3d/components/CesiumViewer').then((module) => module.CesiumViewer),
  {
    ssr: false,
  }
);

export enum DataSettingMode {
  light = 'light',
  detailed = 'detailed',
}
export interface DataSetting {
  referencePoint: boolean; //基準点
  ortho: boolean; //オルソ画像
  design: boolean; //起工測量
  groundSurvey: PointDataSetting; //地上測量
  asBuilt: PointDataSetting; //竣工測量
  soilAmountTasks: boolean; //土量(出来高進捗)
  soilAmountMeasurementItems: boolean; //土量(出来形帳票)
}

export type PointDataSetting = { show: boolean; mode: DataSettingMode; changeable: boolean };

const initialSetting: DataSetting = {
  referencePoint: true,
  ortho: false, // オルソ画像 OFF
  design: true, // 設計 ON
  groundSurvey: {
    show: true,
    mode: DataSettingMode.light,
    changeable: true,
  },
  asBuilt: {
    show: false, // 出来高 OFF
    mode: DataSettingMode.light,
    changeable: true,
  },
  soilAmountTasks: false,
  soilAmountMeasurementItems: false,
};

export type SiteTopProps = {
  dataSetting: DataSetting;
};

const selectableDataSetting: SelectableDataSetting = {
  referencePoint: true,
  ortho: true,
  design: true,
  groundSurvey: true,
  asBuilt: true,
  soilAmountMeasurementItems: false,
  soilAmountTasks: false,
  selectDesignData: true,
  selectPointSize: true,
};
const defaultIsOn = true;
export const SiteTopTemplate = () => (
  <>
    <CesiumViewer
      selectableDataSetting={selectableDataSetting}
      defaultDataSetting={initialSetting}
      defaultIsOnSettingMenu={defaultIsOn}
      willResetDesignSurface
      isShowSensor
    />

    <Data3dRegistration />
  </>
);
